export default "__VITE_ASSET__BOMS6VJZ__"